(function($) {

    //console.log(site_data.SPEEDBUMP_SAFELIST);
    
    $("a[href^='http://'],a[href^='https://']").not('.js-timetrade-popup').on('click', function (e) {
        var targetUrl = $(this).attr('href');
        var blnSafe = site_data.SPEEDBUMP_SAFELIST.some( (domain) => targetUrl.indexOf(domain) >= 0 );

        if (!blnSafe) {
            e.preventDefault();

            var targetWin = $(this).attr('target') ? $(this).attr('target') : '_blank';
            $('#popup-speedbump .btn').attr('href', targetUrl).attr('target', targetWin);

            $.magnificPopup.open({
                items: {
                    type: 'inline',
                    src: '#popup-speedbump',
                },
                alignTop: true,
                fixedContentPos: true,
                mainClass: 'mfp-fade mfp-speedbump',
                showCloseBtn: false,
                modal: true
            });
            $(document).on('click', '.continue-popup-close', function (e) {
                $.magnificPopup.close();
            });
            $(document).on('click', '.popup-cancel', function (e) {
                e.preventDefault();
                $.magnificPopup.close();
            });


        }
    });

})(jQuery);
